import React, { CSSProperties, useEffect, useState } from 'react'

import { useEditor, useNode } from '@craftjs/core'
import { FormProps } from '../../types/props'
import { getStyle } from '../../services/HelperService'
import { FormRenderer } from '../FormRenderer/FormRenderer'
import { Dialog, DialogContent, IconButton, useMediaQuery } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useModal, useRecipient } from '../../contexts/RecipientContext'

import './Form.scss'

export const Form = (formProps: FormProps) => {
	const {id, parent} = useNode(node => ({
		id: node.id, 
		parent: node.data.parent as string
	}))
	// const [step, setStep] = useState(formProps.activeStep) // should not use the formactive step from editor
	const [step, setStep] = useState(0) // should be always in initial step until and unless there is slug activated
	const [survey, setSurvey] = useState(null)
	const { query: {node} } = useEditor()
	const mobile = useMediaQuery('(max-width:500px)')
  const {recipient}: any = useRecipient()
	const {currentModalId, setCurrentModalId} = useModal()

	let parentNode = node(parent).get()
	let style: CSSProperties = {
		...getStyle(formProps.style, formProps.mobileStyle, parentNode, mobile)
	}

	useEffect(() => {
		if (step !== -1) {
			if (recipient?.initialOptions?.content_type === 'CONFIRM') {
				setStep(-1)
			} else if (recipient?.initialOptions?.current_step) {
				setStep(recipient.initialOptions?.current_step)
			} else {
				setStep(0)
			}
		}
	}, [recipient])

	const onStepUpdated = (step: number) => {
		setStep(step)
		// setProp((props: FormProps) => props.activeStep = step)
	}

	const onSurveyUpdated = (survey: any) => {
		setSurvey(survey)
	}

	const handleModalOpen = () => {
		setCurrentModalId(id)
	}

	const handleModalClose = () => {
		setCurrentModalId(null)
		onStepUpdated(0)
	}

	const shouldOpenModal = step !== 0 || survey

	useEffect(() => {
		if(shouldOpenModal && currentModalId === null) {
			handleModalOpen()
		}
	}, [step, survey])

	return <div id={id}
		onClick={(event) => event.stopPropagation()}
		style={{boxSizing: 'border-box', minHeight: 'fit-content', ...style}}>
		<FormRenderer form={formProps}
			step={0}
			popup={false}
			onStepUpdated={onStepUpdated}
			onSurveyUpdated={onSurveyUpdated}/>
		<Dialog open={shouldOpenModal && currentModalId === id}
			onClose={handleModalClose}>
			<DialogContent sx={formProps.dialog?.style || {}}>
				<FormRenderer form={formProps}
					survey_init={survey}
					step={step}
					onStepUpdated={onStepUpdated}
					onSurveyUpdated={onSurveyUpdated}/>
			</DialogContent>
			<IconButton aria-label="close"
          onClick={handleModalClose}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            color: (theme) => theme.palette.grey[500],
          }}>
          <CloseIcon />
        </IconButton>
		</Dialog>	
	</div>
}

Form.craft = {
  displayName: 'Form'
}